import {makeAutoObservable, observable, toJS} from 'mobx';

import {
  ComplimentNotification,
  Notification,
  OrdinaryNotification,
  VisitNotification,
} from './types';

/**
 * Class dedicated to move store messages and manage them from Notifications component
 */
class NotificationStore {
  messages = observable.array<Notification>();

  constructor() {
    makeAutoObservable(this);
  }

  getRawMessages() {
    return toJS(this.messages);
  }

  addNotification(payload: OrdinaryNotification['payload']) {
    this.messages.push({
      id: String(Date.now()),
      type: 'ordinary',
      payload,
    } satisfies OrdinaryNotification);
  }

  addComplimentNotification(payload: ComplimentNotification['payload']) {
    this.messages.push({
      id: String(Date.now()),
      type: 'compliment',
      payload,
    } satisfies ComplimentNotification);
  }

  addVisitNotification(payload: VisitNotification['payload']) {
    this.messages.push({
      id: String(Date.now()),
      type: 'visit',
      payload,
    } satisfies VisitNotification);
  }

  removeMessage(message: Notification) {
    this.messages.remove(message);
  }

  clear() {
    this.messages.clear();
  }
}

const notificationStore = new NotificationStore();
export default notificationStore;
